export default __webpack_public_path__ + "349e51fa9467a725929c54cacbb7135b.webp";